<template>
  <div>
    <md-card>
      <md-card-content>
        <h3>Hire Invoice</h3>

        <hr class="hr-s">

        <div class="box">
          <div class="box-header">
            <h3 class="box-title">Client Name: {{clientName}}</h3>
            <h3 class="box-title">Contract Series:{{clientSeries}}</h3>
          </div>
          <hr class="hr-s">
          <!-- /.box-header -->
          <div class="box-body">
            <table id="viewSalesBooking" class="table table-bordered table-striped">
              <thead>
                <tr>
                  <th>Sr no</th>
                  <th>Invoice Month</th>
                  <th>No of days</th>
                  <th>View Invoice</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(item1,index) in clientListView" :key="index">
                  <td>{{index+1}}</td>
                  <td>{{item1.month}} , {{item1.year}}</td>
                  <td>{{days[index]}}</td>

                  <td>
                    <md-button
                      class="md-icon-button md-raised md-dense"
                      @click="viewInvoice(item1.month1,item1.year,days[index])"
                    >
                      <md-icon>visibility</md-icon>
                    </md-button>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <!-- /.box-body -->
        </div>
      </md-card-content>
    </md-card>
  </div>
</template>




<script>
import axios from "axios";
import moment from "moment";
import DatePicker from "vue2-datepicker";

import { URL_BASE, URL_BASE_DOC } from "../../../helper/constant.js";
import { DateFormat, selectDateFormat} from "../../../helper/filters";
import { globalPermissionStatus } from "../../../helper/collection";

export default {
  beforeMount() {
    if (
      this.$sessionsStorage.get("loginId") != undefined &&
      this.$sessionsStorage.get("loginId") != ""
    ) {
      this.$store.dispatch("setCurrentRoute", "/viewHireInvoice/");

      if (
        this.$sessionsStorage.get("clientId") != undefined &&
        this.$sessionsStorage.get("clientId") != "" &&
        this.$sessionsStorage.get("setContractId") != undefined &&
        this.$sessionsStorage.get("setContractId") != ""
      ) {
        this.getData();
      }
    } else {
      this.$router.push({
        path: "/Login/"
      });
    }
  },

  data() {
    return {
      clientListView: [],
      clientName: "",
      clientSeries: "",
      days: []
    };
  },

  mounted() {
    // this.JqueryFun()
  },
  filters: {
    moment(date) {
      return DateFormat(date)
    }
  },

  beforeDestroy() {},

  destroyed() {},

  components: {},

  computed: {},

  methods: {
    JqueryFun() {
      return $(function() {
        return $("#viewSalesBooking").DataTable();
      });
    },
    viewInvoice(month, year, days) {
      this.$sessionsStorage.set("setMonth", month);
      this.$sessionsStorage.set("setYear", year);
      this.$sessionsStorage.set("setdays", days);
      this.$router.push({
        path: "/hireInvoice"
      });
    },

    getData() {
      let payload = {
        contractId: this.$sessionsStorage.get("setContractId"),

        clientId: this.$sessionsStorage.get("clientId")
      };

      let options = {
        method: "POST",
        url: `${URL_BASE}/Api_TPTContract/viewHireContractInvoice.php`,
        data: JSON.stringify(payload),
        crossDomain: true,
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: this.$sessionsStorage.get("loginId")
        }
      };
      axios(options)
        .then(result => {
          const { statusText, status, data } = result;
          if (
            data.clientId != "" &&
            
            status == 200 &&
            data
          ) {
            if (data.allclient1.length > 0) {
              this.clientListView = data.allclient1;
            }
            this.clientName = data.clientName;
            this.clientSeries = data.clientSeries;
            this.days = data.daysCount;
            this.JqueryFun();
            //console.log(data);
          }
        })
        .catch(error => {});
    }
  }
};
</script>
<style>
</style>




// WEBPACK FOOTER //
// viewHireInvoice.vue?41dc2e1f